export const PensionInsuranceRoutes = {
    ROOT: "/pension-insurance",
    PERSONAL_DATA: "/pension-insurance/personal-data",
    NEW_PHONE: "/pension-insurance/new-phone",
    NEW_ADDRESS: "/pension-insurance/new-address",
    SUCCESS: "/pension-insurance/success"
};



// WEBPACK FOOTER //
// ./src/components/pensionInsurance/PensionInsuranceRoutes.ts